export default "__VITE_ASSET__C6PQS0vW__"